import Typography from "@mui/material/Typography";
import PaidIcon from "@mui/icons-material/Paid";
import Button from "@mui/material/Button";
import { numberRegex } from "Admin/Utils/numberRegex";
import { Tag } from "antd";
import styles from "./ProfileGrant.module.scss";
const ProfileGrant = ({ award }) => {
  return (
    <div className={styles["profile-grant"]}>
      <div
        className={styles["title"]}
        onClick={() => {
          if (award.award_url) {
            window.open(award.award_url);
          }
        }}
      >
        <span>
          <b>{award.award_title}</b>
        </span>
        {award.program_title !== "None" && (
          <span className={styles["venue"]}>
            <i>. {award.program_title}</i>
          </span>
        )}
      </div>
      <div className={styles["award-number"]}>
        <span>
          <span className={styles["section-title"]}>Award number:</span>
          <span style={{ fontStyle: "italic" }}>
            {" "}
            {award.award_number}
          </span>.{" "}
        </span>
      </div>

      <div className={styles["award-number"]}>
        <span style={{ color: "var(--blue)", fontWeight: "500" }}>
          {award.start_date} / {award.end_date}
        </span>
      </div>
      <div className={styles["sponsors"]}>
        <span className={styles["section-title"]}>Sponsors:</span>{" "}
        {award.sponsors &&
          award.sponsors?.map((item, index) => {
            return <span key={index}>{item["#text"]}; </span>;
          })}
      </div>
      <div className={styles["coauthors"]}>
        <span>
          <span className={styles["section-title"]}>
            Principal investigators:
          </span>{" "}
          {award.principal_investigators}
        </span>
      </div>
      <div className={styles["dates"]}>
        <p></p>
      </div>
      <div className={styles["tags"]}>
        {award.keywords?.map((item, index) => {
          return <Tag key={index}>{item.id}</Tag>;
        })}
      </div>
      <div className={styles["action"]}>
        {/* {award.amount_awarded != 0 && (
          <Button
            style={{
              backgroundColor: "white",
              color: "#b45f06",
              borderRadius: 10,
              height: 25,
              paddingLeft: 0,
              textAlign: "left",
              textTransform: "none",
              marginRight: "10px",
            }}
          >
            <PaidIcon />
            <Typography align={"left"} style={{ fontSize: 12 }}>
              {numberRegex(parseFloat(award.amount_awarded))}
            </Typography>
          </Button>
        )} */}
      </div>
    </div>
  );
};

export default ProfileGrant;
